import classNames from 'classnames';
import H from 'history';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { AllApplicationPermissions } from '../../Config/PermissionConfig';
import { isUserAuthorised } from '../../Hooks/usePermissionLoader';
import { withPermissionCheck } from '../Auth/PermissionsCheck';
import styles from './NavMenu.module.scss';

type NavMenuItemProps = {
    icon: JSX.Element;
    title: string;
    pathname: string;
    location: string;
    disabled?: boolean;
    referrerLocation?: H.Location;
    isNavModal?: boolean;
    replace?: boolean;
    collapses?: boolean;
    permissions?: AllApplicationPermissions;
    onClick?(e: React.MouseEvent<HTMLAnchorElement>): void;
    exact?: boolean;
};

export const NavMenuItem = (props: NavMenuItemProps) => {
    const authorised = props.permissions ? isUserAuthorised(props.permissions) : true;
    const textClass = classNames(styles.text, {
        [styles.navCollapses]: props.collapses,
        [styles.textDisabled]: props.disabled
    });

    if (!authorised) return null;

    if (props.disabled) {
        const disabledLink = classNames(styles.link, {
            [styles.linkDisabled]: props.disabled
        });
        return (
            <div className={disabledLink}>
                {React.cloneElement(props.icon, { className: styles.icon })}
                <div className={textClass}>{props.title}</div>
            </div>
        );
    }

    return (
        <NavLink
            to={{ pathname: props.location, state: { referrer: props.referrerLocation, modal: props.isNavModal } }}
            exact={props.exact}
            title={props.title}
            replace={props.replace}
            className={styles.link}
            onClick={props.onClick}
            activeClassName={styles.linkActive}
        >
            {React.cloneElement(props.icon, { className: styles.icon })}
            <div className={textClass}>{props.title}</div>
        </NavLink>
    );
};

export const NavMenu: React.FC<{
    collapses?: boolean;
    isCollapsed?: boolean;
}> = props => {
    const navMenuClass = classNames(styles.links, {
        [styles.collapsed]: props.isCollapsed
    });

    return (
        <div className={navMenuClass}>
            {React.Children.map(props.children, (child: any) => {
                if (!!child) return React.cloneElement(child, { collapses: props.collapses });

                return null;
            })}
        </div>
    );
};
